<template>
  <!-- content_wrapper_start -->
  <div>
    <!-- container_content_wrapper_start -->
    <b-container fluid style="height: calc(100vh - 181px);">
      <!-- page_title_start -->
      <h5 class="d-block">
        {{ $lang.PCI.Mounting.Title }}
      </h5>
      <!-- <label>{{ $lang.Common.LabelFilter }}:</label>
      <b-input type="date" v-model="keyFilterDate"></b-input> -->
      <!-- page_title_end -->

      <!-- pcis_selection_wrapper_start -->
      <b-row style="height: calc(100vh - 250px);">
        <!-- contracts_start -->
        <b-col cols="12" class="py-3">
          <!-- contracts_grid_wrapper_start -->
          <ag-grid-vue
            class="ag-theme-alpine"
            :getLocaleText="localeTextFunc"
            :gridOptions="gridOptions"
            :columnTypes="columnTypes"
            :defaultColDef="defaultColumnDef"
            :columnDefs="columnDefs"
            :rowData="contracts"
            rowSelection="single"
            @rowDoubleClicked="selectContract"
            @rowSelected="onSelectLine"
            :getRowId="params => params.data.contractID"
            :suppressContextMenu="true"
            :rowHeight="25"
            :headerHeight="30"
            style="width: 100%; height: 100%; border-radius: 6px;"
            >
            <!-- :rowData="availableContracts" -->
          </ag-grid-vue>
          <!-- contracts_grid_wrapper_end -->
        </b-col>
        <!-- contracts_end -->
      </b-row>
      <!-- pcis_selection_wrapper_end -->

      <!-- actions_row_start -->
      <b-row>
        <!-- select_button_start -->
        <b-col cols="12" class="d-flex">
          <div class="d-flex">
            <b-button
              @click="selectContract"
              :disabled="!selectedLine"
              variant="third"
            >
              <i class="fas fa-check"></i> {{ $lang.Common.Select }}
            </b-button>
            <b-button
              @click="openExportMenu"
              :disabled="!selectedLine || !selectedLine.pciID"
              variant="third"
              class="ml-3"
            >
              {{ $lang.PCI.Mounting.ExportButtonTitle }}
            </b-button>
          </div>
          <div class="d-flex justify-content-end w-100">
            <b-button variant="danger"  class="ml-3" v-if="hasRole(roles.RW_OPER_PCI_ARCHIVE_FINANCE) && selectedLine && selectedLine.pciID && !selectedLine.archivedFinance" @click="onArchiveFinance">
              <i class="fas fa-box"></i> {{ $lang.PCI.Mounting.LabelArchiveFinance }}
            </b-button>
            <b-button variant="danger"  class="ml-3" v-if="hasRole(roles.RW_OPER_PCI_ARCHIVE_FINANCE) && selectedLine && selectedLine.pciID && selectedLine.archivedFinance" @click="onUnarchiveFinance">
              <i class="fas fa-box-open"></i> {{ $lang.PCI.Mounting.LabelUnarchiveFinance }}
            </b-button>
            <b-button variant="warning" class="ml-3" v-if="hasRole(roles.RW_OPER_PCI_ARCHIVE_WORKS) && selectedLine && selectedLine.pciID && !selectedLine.archivedWorks" @click="onArchiveWork">
              <i class="fas fa-box"></i> {{ $lang.PCI.Mounting.LabelArchiveWorks }}
            </b-button>
            <b-button variant="warning" class="ml-3" v-if="hasRole(roles.RW_OPER_PCI_ARCHIVE_WORKS) &&selectedLine && selectedLine.pciID && selectedLine.archivedWorks" @click="onUnarchiveWork">
              <i class="fas fa-box-open"></i> {{ $lang.PCI.Mounting.LabelUnarchiveWorks }}
            </b-button>
            <b-button variant="link" class="ml-3" v-if="selectedLine && selectedLine.pciID" @click="showLog">
              <i class="fas fa-history"></i> Log
            </b-button>
          </div>
        </b-col>
        <!-- select_button_end -->
      </b-row>
      <!-- actions_row_end -->
    </b-container>
    <!-- container_content_wrapper_end -->

    <!-- pci_itens_modal_start -->
    <b-modal
      id="pci-items-modal"
      v-model="showPciItemsModal"
      size="xl"
      :ok-title="$lang.Common.Buttons.Save"
      :cancel-title="$lang.Common.Buttons.Back"
      @ok="submitPCI"
      @hide="closePCI"
      no-close-on-backdrop
    >
      <!-- :ok-disabled="!(listLpuPci && listLpuPci.length)" -->
      <template #modal-title>
        <span v-if="contractToExport">
          {{ $lang.PCI.Mounting.TitleSelectItemsToExport }}
        </span>
        <span v-else>
          ({{selectedContract.contract}})
        </span>
      </template>
      <div class="d-flex h-100">
        <div class="treeview-content col-md-6">
          <b-card class="col-md-12 mb-1 px-0" no-body>
            <template #header>
              <i class="fas fa-cogs"></i><span>{{ $lang.PCI.Mounting.LabelItems }}</span>
            </template>
          </b-card>
          <item-tree-view
            ref="mountingTreeview"
            :list="pciItemsTree"
            :showCheckbox="true"
            :serializer="p => `(${p.value}) ${p.name}`"
            v-on:checkitem="onCheckItem"
            @scrollTo="onScrollTo"
          >
            <template #afterSerialize="slotProps">
              <b-form-radio-group v-if="slotProps.item.tipo === 9" v-model="slotProps.item.linhaCandidato" :disabled="!slotProps.item.checked" size="sm">
                <b-form-radio :value="false">Lin. Princ.</b-form-radio>
                <b-form-radio :value="true">Lin. Cand.</b-form-radio>
              </b-form-radio-group>
              <b-form-checkbox switch v-if="slotProps.item.possuiCor" v-model="slotProps.item.colorido" :disabled="!slotProps.item.checked"><i class="fas fa-palette text-primary"></i></b-form-checkbox>
              <b-form-checkbox switch v-if="slotProps.item.bloqueiaRetroativoModelo" v-model="slotProps.item.bloqueiaRetroativo" :disabled="!slotProps.item.checked"><i class="fas fa-calendar text-primary" :title="$lang.PCI.Mounting.RetroactiveDateTitle"></i></b-form-checkbox>
              <b-dropdown class="ml-2" size="sm" variant="light" squared v-if="slotProps.item.validations.length" :disabled="!slotProps.item.checked">
                <template #button-content>
                  {{ $lang.PCI.Mounting.LabelValidations }}
                  <b-badge variant="info">{{slotProps.item.mountValidations.length}}/{{slotProps.item.validations.length}}</b-badge>
                </template>
                <v-select @input="onCheckValidations"
                          :options="slotProps.item.validations"
                          v-model="slotProps.item.mountValidations"
                          :reduce="valid => valid.value"
                          label="text"
                          multiple
                          style="width: 500px;">
                </v-select>
              </b-dropdown>
              <b-dropdown class="ml-2" size="sm" variant="light" squared v-if="slotProps.item.automations.length" :disabled="!slotProps.item.checked">
                <template #button-content>
                  {{ $lang.PCI.Mounting.LabelAutomations }}
                  <b-badge variant="info">{{slotProps.item.mountAutomations.length}}/{{slotProps.item.automations.length}}</b-badge>
                </template>
                <v-select @input="onCheckAutomations"
                          :options="slotProps.item.automations"
                          v-model="slotProps.item.mountAutomations"
                          :reduce="autom => autom.value"
                          label="text"
                          multiple
                         style="width: 300px;">
                </v-select>
              </b-dropdown>
            </template>
          </item-tree-view>
        </div>
        <div class="col-md-6">
          <div style="max-height: 20vh; overflow-y: auto;">
            <b-alert show variant="danger" v-for="(item, index) in inconsistencies" :key="index" style="font-size:.75rem;">
              <span>{{ item.originName }}</span><br>
              <strong class="ml-2">{{ $lang.PCI.Mounting.ValidationMessage }}</strong><br>
              <span>{{ item.destinyName }}</span>
            </b-alert>
          </div>
          <b-card class="col-md-12 mb-1 px-0" no-body>
            <template #header>
              <i class="fas fa-link"></i><span>{{ $lang.PCI.Mounting.LabelLinkedContract }}</span>
            </template>
          </b-card>
          <v-select v-if="!contractToExport" v-model="selectedContract.linkedContractID" :options="contractsToLink" label="contract" :reduce="param => param.contractID" :placeholder="`-- ${$lang.PCI.Mounting.PlaceholderSelectLinkedContract} --`" class="mb-3"></v-select>
          <b-card class="col-md-12 mb-1 mt-3 px-0" no-body>
            <template #header>
              <i class="fas fa-list"></i> {{$lang.PCI.Mounting.LabelLpu}}
            </template>
          </b-card>
          <div class="d-flex flex-row align-items-center" v-for="(option, index) in listLpuSel" :key="option.id">
            <div class="flex-grow-1 form-control">
              {{ option.lpu.cliente + '-' + option.lpu.descricao + '-' + option.lpu.regiao + ' Rv.' + option.lpu.revisao }}
            </div>
            <i class="fas fa-trash pointer m-1 text-danger" @click="onDeleteLpu(index)" v-b-tooltip.hover :title="$lang.Common.Buttons.Delete"></i>
          </div>
          <v-select class="m-1"
                    v-model="addLpu"
                    :options="listLpu"
                    :getOptionLabel="option => option.cliente + '-' + option.descricao + '-' + option.regiao + ' Rv.' + option.revisao"
                    @input="onAddLpu"
                    :placeholder="`-- ${$lang.PCI.Mounting.PlaceholderSelectLpu} --`">
          </v-select>
        </div>
      </div>
    </b-modal>
    <!-- pci_itens_modal_end -->

    <!-- export_menu_modal_start -->
    <b-modal
      v-model="showExportModal"
      size="lg"
      :ok-title="$lang.Common.Select"
      :cancel-title="$lang.Common.Buttons.Back"
      :title="$lang.PCI.Mounting.ExportModalTitle"
      @ok="selectContractExport"
      no-close-on-backdrop
    >
      <input
        type="text"
        class="form-control"
        id="search-contract-export"
        :placeholder="$lang.Common.Buttons.Search"
        @input="searchExportContract"
      />

      <div class="treeview-content">
        <item-tree-view
          ref="pciTreeview"
          :list="exportContracts.filter(p => p.show === true)"
          :showCheckbox="true"
          :showSearch="false"
          :close="true"
          :serializer="p => p.contract"
        >
        </item-tree-view>
      </div>
    </b-modal>
    <!-- export_menu_modal_end -->

    <!-- log_start -->
    <log ref="Log" v-if="showLog" @hide="showLogs = false" :listLpu="listLpuAll" :listContract="contracts">
    </log>
    <!-- log_end -->

  </div>
  <!-- content_wrapper_end -->
</template>

<script>
import Mounting from './mounting'
export default Mounting
</script>

<style scoped>
#search-contract-export:focus {
  box-shadow: none !important;
}

* >>> .item-found {
  color: red;
  font-weight: bold;
}

* >>> #pci-items-modal .modal-body {
  height: calc(100vh - 185px);
  overflow-x: auto;
}

button {
  text-wrap: nowrap;
}

i {
  font-size: 1rem;
  cursor: pointer;
}

.icon-delete {
  display: none;
}
.div-lpu:hover .icon-delete {
  display: flex;
}

input.form-control {
  font-size: 12px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

::-webkit-scrollbar-track {
  border-radius: 12px !important;
  background: #fcfcfc !important;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px !important;
  background: #c2c2c2 !important;
}

::-webkit-scrollbar {
  width: 5px !important;
  height: 5px !important;
}

::-webkit-scrollbar-thumb:hover {
  border-radius: 10px !important;
  background: #a1a1a1 !important;
}

.treeview-content {
  height: calc(100vh - 255px);
}

/* * >>> .treeview ul {
  height: calc(100% - 10px) !important;
} */
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/mounting/mounting.vue